// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"379":"73d6a659","524":"d7c4fa5c","612":"0d50a473","801":"0e333e63"}[chunkId] + ".chunk.css";
};